"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleFutureMarginCalculator = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const GridTradingUtils_1 = require("../../GridTrading/GridTradingUtils");
class SingleFutureMarginCalculator {
    constructor(symbol) {
        this.isFullPosition = false;
        this.symbol = symbol;
    }
    static CalculateLiquidationPriceFunctionOne(mmRate, initMargin, openPrice, position, trend) {
        //计算维持保证金 = 开仓均价 * 仓位 * 维持保证金率
        const maintainMargin = openPrice.mul(position).mul(mmRate);
        const offset = initMargin.sub(maintainMargin).div(position).absoluteValue();
        if (trend === "long") {
            return openPrice.sub(offset);
        }
        else {
            return openPrice.add(offset);
        }
    }
    getInitMargin(position, open_price, leverage_rate, fullMargin) {
        const initMargin = this.isFullPosition ? new trade_utils_lib_1.SafeDecimal(fullMargin) : open_price.mul(position).div(leverage_rate);
        return initMargin;
    }
    // fullMargin 全仓保证金: 逐仓模式不需要填入
    getFutureMarginInfo(top, bottom, count, trend, gridType, invest, curPrice, triggerPrice, leverageRate, fee, fullMargin) {
        const gridBaseInvest = '0'; // 运行网格的base资金
        const gridQuoteInvest = invest; // 运行网格的quote资金
        const openPrice = triggerPrice || curPrice;
        const perVolume = GridTradingUtils_1.GridTradingUtils.getPerGridValume(top, bottom, count, gridBaseInvest, gridQuoteInvest, openPrice, gridType, trend);
        const perVolumeStr = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(perVolume, this.symbol.amount);
        const avgPriceInfos = this.getGridsEachAverageOpenPriceAndPositions(top, bottom, count, trend, gridType, openPrice, perVolumeStr);
        if (!avgPriceInfos.length) {
            return { liquidationPrice: "" };
        }
        let liquidationPrice = "";
        for (let i = 0; i < avgPriceInfos.length; i++) {
            const priceInfo = avgPriceInfos[i];
            const gridPrice = new trade_utils_lib_1.SafeDecimal(priceInfo.gridPrice);
            const avgPrice = new trade_utils_lib_1.SafeDecimal(priceInfo.avgPrice);
            const position = new trade_utils_lib_1.SafeDecimal(priceInfo.position);
            const leverageRateDecimal = new trade_utils_lib_1.SafeDecimal(leverageRate);
            const initMargin = this.getInitMargin(position, avgPrice, leverageRateDecimal, fullMargin);
            let result = this.getLiquidationPrice(initMargin, avgPrice, position, leverageRateDecimal, trend);
            if (result.lessThan(0)) {
                result = new trade_utils_lib_1.SafeDecimal(0);
            }
            // 看多价格为递增, 看空为递减
            if (trend === "long") {
                if (result.lessThanOrEqualTo(gridPrice)) {
                    liquidationPrice = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(result, this.symbol.precision, trade_utils_lib_1.SafeDecimal.ROUND_CEIL);
                    break;
                }
            }
            else {
                if (result.greaterThanOrEqualTo(gridPrice)) {
                    liquidationPrice = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(result, this.symbol.precision, trade_utils_lib_1.SafeDecimal.ROUND_FLOOR);
                    break;
                }
            }
        }
        return {
            liquidationPrice: liquidationPrice
        };
    }
    getGridsEachAverageOpenPriceAndPositions(top, bottom, count, trend, gridType, curPrice, perVolume) {
        if (!Number(top) || !Number(bottom) || !Number(count) || Number(count) < 2 || Number(top) <= Number(bottom)) {
            return [];
        }
        if (!Number(perVolume) || !Number(curPrice)) {
            return [];
        }
        const _perVolume = new trade_utils_lib_1.SafeDecimal(perVolume);
        const _curPrice = new trade_utils_lib_1.SafeDecimal(curPrice);
        const _count = new trade_utils_lib_1.SafeDecimal(count);
        const priceInfo = [];
        const priceArr = GridTradingUtils_1.GridTradingUtils.getPriceInterverArr(top, bottom, count, gridType);
        if (priceArr.length <= 0) {
            return [];
        }
        const curPriceIndex = GridTradingUtils_1.GridTradingUtils.findPriceIndexInArr(priceArr, _curPrice.toString());
        if (trend === 'long') {
            // 计算开仓均价: 当前价格之上, 均价买入, 当前向上按格子价格买入
            let avgOpenPrice = _curPrice;
            for (let i = 0; i < priceArr.length; i++) {
                // 计算开仓均价
                if (new trade_utils_lib_1.SafeDecimal(i).lessThan(curPriceIndex)) {
                    const upperSumPrice = _curPrice.mul(_count.sub(1).sub(new trade_utils_lib_1.SafeDecimal(curPriceIndex)));
                    let lowerSumPrice = new trade_utils_lib_1.SafeDecimal(0);
                    for (let j = i; j < curPriceIndex; j++) {
                        lowerSumPrice = lowerSumPrice.add(priceArr[j]);
                    }
                    avgOpenPrice = upperSumPrice.add(lowerSumPrice).div(new trade_utils_lib_1.SafeDecimal(priceArr.length - 1 - i));
                }
                else {
                    avgOpenPrice = _curPrice;
                }
                // 看多最低价的时候为满仓, 涨一格, 平一单.
                const baseAmount = _perVolume.mul(_count.sub(1).sub(i));
                priceInfo.push({ gridPrice: priceArr[i].toString(), avgPrice: avgOpenPrice.toString(), position: baseAmount.toString() });
            }
        }
        else {
            // 计算开仓均价: 当前价格之下, 均价买入, 当前向上按格子价格买入
            let avgOpenPrice = _curPrice;
            for (let i = 0; i < priceArr.length; i++) {
                const index = priceArr.length - 1 - i; // 倒序, 从最高价开始
                // 计算开仓均价
                if (new trade_utils_lib_1.SafeDecimal(index).greaterThan(curPriceIndex)) {
                    const lowerSumPrice = _curPrice.mul(new trade_utils_lib_1.SafeDecimal(curPriceIndex));
                    let upperSumPrice = new trade_utils_lib_1.SafeDecimal(0);
                    for (let j = (curPriceIndex + 1); j <= index; j++) {
                        upperSumPrice = upperSumPrice.add(priceArr[j]);
                    }
                    avgOpenPrice = upperSumPrice.add(lowerSumPrice).div(index);
                }
                else {
                    avgOpenPrice = _curPrice;
                }
                // 看空最高价的时候为满仓, 跌一格, 平一单.
                const baseAmount = _perVolume.mul(index);
                priceInfo.push({ gridPrice: priceArr[i].toString(), avgPrice: avgOpenPrice.toString(), position: baseAmount.toString() });
            }
        }
        return priceInfo;
    }
}
exports.SingleFutureMarginCalculator = SingleFutureMarginCalculator;
